import React from "react";
import { useDispatch } from "react-redux";

import { fetchRequestsWithName } from "../../../../../../../store/devices/requestsWithName";
import { RefreshButton } from "../../../../../../../components/table/components";

export const RequestedDevicesInfo = () => {
  const dispatch = useDispatch();

  return <RefreshButton onClick={() => dispatch(fetchRequestsWithName())} />;
};
